<template>
  <!-- MDC classes added -->
  <main>
    <!-- The ```mdc-top-app-bar--fixed-adjust``` class has been removed because the top bar may overlay the main image -->
    <template v-if="typeof mainImg === 'object'">
      <template
        v-if="mainImg.hasOwnProperty('src') && mainImg.hasOwnProperty('alt')"
      >
        <div class="hero relative h-screen sm:h-auto md:mt-auto overflow-hidden">
          <picture v-if="mainImg.src !== undefined" class="block">
            <template v-if="typeof mainImg.src === 'object'">
              <!-- Large -->
              <source
                v-if="typeof mainImg.src.webp !== 'undefined'"
                :media="`(min-width: ${$store.getters.fullConfig.theme.screens.sm})`"
                :srcset="
                  require(`@/img/${mainImg.src.webp.replace(
                    'main',
                    'main.md'
                  )}`)
                "
                type="image/webp"
              />
              <source
                v-if="mainImg.src.jpg !== undefined"
                :media="`(min-width: ${$store.getters.fullConfig.theme.screens.sm})`"
                :srcset="require(`@/img/${mainImg.src.jpg}`)"
                type="image/jpeg"
              />

              <!-- Mobile -->
              <!-- WebP: Lossless -->
              <source
                v-if="mainImg.src.webp !== undefined"
                :media="`(max-width: ${
                  parseInt($store.getters.fullConfig.theme.screens.sm) - 1
                }px)`"
                :srcset="require(`@/img/${mainImg.src.webp}`)"
                type="image/webp"
              />
              <!-- JPEG: Lossy for those who do not support WebP -->
              <source
                v-if="mainImg.src.jpg !== undefined"
                :media="`(max-width: ${
                  parseInt($store.getters.fullConfig.theme.screens.sm) - 1
                }px)`"
                :srcset="require(`@/img/${mainImg.src.jpg}`)"
                type="image/jpeg"
              />

              <img
                v-if="mainImg.src.jpg !== undefined"
                :class="['w-full']"
                :src="require(`@/img/${mainImg.src.jpg}`)"
                :alt="mainImg.alt"
              />
            </template>
            <template v-else-if="mainImg.src !== undefined">
              <source
                :media="`(min-width: ${$store.getters.fullConfig.theme.screens.sm})`"
                :srcset="
                  require(`@/img/${mainImg.src.replace('main', 'main.md')}`)
                "
                type="image/jpeg"
              />
              <img
                v-if="mainImg.src !== undefined"
                :class="['w-full']"
                :src="require(`@/img/${mainImg.src}`)"
                :alt="mainImg.alt"
              />
            </template>
          </picture>

          <div
            :class="[
              'overlay absolute w-full h-full top-0 left-0',
              'flex flex-column flex-wrap flex-grow flex-shrink-0 items-center justify-center content-center',
              'text-white',
            ]"
          >
            <span
              class="
                caption
                text-2xl
                sm:text-xl
                md:text-2xl
                lg:text-5xl
                text-center
                w-full
                py-1
                px-2
              "
              v-html="mainImg.caption"
            ></span>

            <a
              :href="mainImg.ctaUrl"
              target="_blank"
              :class="[
                'block my-5 sm:my-2 sm:px-2 sm:py-1 sm:text-sm px-4 py-2',
                'bg-white hover:bg-transparent',
                'border-solid border-2',
                'border-transparent hover:border-white',
                'text-mlt-brown hover:text-white font-bold',
                'transition duration-300 ease-out',
                'opacity-1',
              ]"
            >
              {{ mainImg.ctaTitle }}
            </a>
          </div>
        </div>
      </template>

      <template v-if="mainImg.hasOwnProperty('watermark')">
        <!-- If boolean -->
        <template v-if="mainImg.watermark === true">
          <div
            class="watermark absolute"
            v-html="$store.state.globals.brandsSVG.force"
          ></div>
        </template>
        <!-- If object -->
        <div
          v-if="typeof mainImg.watermark === 'object'"
          class="watermark absolute z-5"
          :style="{ ...mainImg.watermark }"
        >
          <picture>
            <img
              :src="require(`@/img/${mainImg.watermark.src}`)"
              :alt="`Watermark | ${mainImg.alt}`"
              :width="mainImg.width"
              :height="mainImg.height"
            />
          </picture>
        </div>
      </template>
    </template>

    <template v-if="$route.path == '/'">
      <Brands />
      <GridTwoColumn />
      <PlainGrid />
    </template>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Brands from "@/components/body/Brands.vue";
import GridTwoColumn from "@/components/body/GridTwoColumn.vue";
import PlainGrid from "@/components/body/PlainGrid.vue";

export default {
  name: "Main",
  props: {
    mainImg: Object,
  },
  components: {
    Brands,
    GridTwoColumn,
    PlainGrid,
  },
  computed: {
    ...mapGetters([]),
  },
  methods: {
    ...mapActions(["genuineLeatherSVG"]),
  },
  data() {
    return {};
  },
  created() {
    this.genuineLeatherSVG().then((res) => (this.watermarkSVG = res));
  },
};
</script>

<style lang="scss">
.hero {
  max-height: calc(100vh - 5rem);
}
.v-application a {
  color: #000;
}
// Brand > Force
#brand-force {
  // .hero {
  // 	margin-top: 56px;
  // }
  // Brand Watermark White colour
  // .caption {
  // 	position: absolute;
  // 	right: -10rem;
  // 	color: #fff;
  // }
  .watermark svg path,
  .watermark svg rect {
    stroke: #fff;
    stroke-width: 0px;
    fill: #fff;
  }
  .watermark {
    bottom: 1rem;
    width: 10rem;
    left: 2rem;
  }
}
// Brand > Classic Milano
#brand-classic-milano {
  .caption {
    color: beige;
  }
}
// Brand > Cliff
#brand-cliff {
  .watermark {
    svg path {
      fill: "";
    }
  }
}
</style>
